import api from "../config/api";
import { EmployeeAttendance } from "../types/Attendance";

const API_URL = "/employeeAttendance";

// Get all employee attendance records
export const getAllEmployeeAttendance = () =>
  api.get(`${API_URL}/`).then((res) => {
    // console.log("data",res.data.data);
    return res.data.data;
  });

// Get attendance by ID using query parameter
export const getEmployeeAttendanceById = (id: number) =>
  api.get(`${API_URL}/?id=${id}`);

// Create a new attendance record
export const createEmployeeAttendance = (data: EmployeeAttendance) =>
  api.post(`${API_URL}/`, data);

// Update an attendance record
export const updateEmployeeAttendance = (
  id: number,
  data: EmployeeAttendance,
) => api.put(`${API_URL}/?id=${id}`, data);

// Delete an attendance record
export const deleteEmployeeAttendance = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
